module.exports = __webpack_public_path__ + "static/media/32.23f66c20.wav";